import React from 'react';
export function SevenDayPlan() {
  return <section className="py-10 px-4 bg-gray-900 text-white" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-yellow-400" data-id="element-119">
          📅 PLAN CLARO DE 7 DÍAS
        </h2>

        <div className="grid gap-3 max-w-2xl mx-auto" data-id="element-120">
          {[{
          day: 'Día 1',
          desc: 'Entendés qué está pasando'
        }, {
          day: 'Día 2-3',
          desc: 'Ajustás señales y rutinas'
        }, {
          day: 'Día 4-5',
          desc: 'Reducís despertares'
        }, {
          day: 'Día 6-7',
          desc: 'Consolidás el descanso'
        }].map((step, i) => <div key={i} className="flex items-center gap-5 bg-gray-800 p-5 rounded-xl border border-gray-700" data-id="element-121">
              <div className="w-11 h-11 bg-blue-600 rounded-full flex items-center justify-center font-bold text-white flex-shrink-0" data-id="element-122">
                {i + 1}
              </div>
              <div data-id="element-123">
                <h3 className="text-lg font-bold text-blue-400 mb-0.5" data-id="element-124">
                  {step.day}
                </h3>
                <p className="text-base text-gray-200" data-id="element-125">{step.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-8" data-id="element-126">
          <p className="text-2xl font-bold text-white bg-white/10 inline-block px-8 py-3 rounded-full" data-id="element-127">
            👉 No es magia. Es método
          </p>
        </div>
      </div>
    </section>;
}